<script setup lang="ts">
const props = defineProps<{
  isBordered?: boolean;
  isHighlighted?: boolean;
}>();
</script>

<template>
  <div
    class="le-article-hoverable-area"
    :class="{
      'le-article-hoverable-area--border-without-hover': props.isBordered,
      'le-article-hoverable-area--highlight': props.isHighlighted
    }"
  >
    <slot />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-hoverable-area {
  margin: -7px -6px -8px @dictsys-article-hoverable-area__left-spacing;
  padding: 7px 6px 8px abs(@dictsys-article-hoverable-area__left-spacing);
  border-radius: 4px;

  &:hover:not(.le-article-hoverable-area--border-without-hover) {
    background-color: @colors[@secondary][100];
  }

  &--border-without-hover {
    margin-top: -8px;
    margin-left: @dictsys-article-inflection-scheme__left-spacing;
    border: 1px solid @colors[@secondary][300];
  }

  &--highlight {
    background-color: @colors[@secondary][300];
  }
}
</style>
